var React = require('react');

function Patreon (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","d":"\n\t\tM15.7,3.3c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.7,6.8,6.7c3.7,0,6.7-3,6.7-6.7C22.4,6.3,19.4,3.3,15.7,3.3","key":0}),React.createElement("rect",{"x":"3.7","y":"3.3","strokeLinecap":"round","strokeLinejoin":"round","width":"3.3","height":"18","key":1})]));
}

Patreon.defaultProps = {"version":"1.1","id":"Layer_1","width":"24","height":"24","x":"0px","y":"0px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = Patreon;

Patreon.default = Patreon;
